/**
 * Forestry Module Routes (custom extensions)
 *
 * Extends the auto-generated routes with custom routes such as the
 * GIS-observation workflow that is not generated from entity DSL.
 */

import { lazy, Suspense } from 'react'
import { forestryRoutes as generatedForestryRoutes } from './forestry.generated'

const WorkorderObservePage = lazy(() =>
  import('@/forestry/gis/WorkorderObservePage').then((m) => ({ default: m.WorkorderObservePage }))
)

const ForestrySettingsPage = lazy(() =>
  import('@/forestry/settings/ForestrySettingsPage.generated').then((m) => ({ default: m.ForestrySettingsPage }))
)

export const forestryRoutes = [
  ...generatedForestryRoutes,
  {
    path: '/forestry/workorders/:id/observe',
    element: (
      <Suspense fallback={null}>
        <WorkorderObservePage />
      </Suspense>
    ),
  },
  {
    path: '/forestry/settings',
    element: (
      <Suspense fallback={null}>
        <ForestrySettingsPage />
      </Suspense>
    ),
  },
]
